module.exports = __webpack_public_path__ + "static/media/ITHelp.6e230ac6.png";